import { cn } from '@/lib/utils'
import { IconLoader } from '@tabler/icons-react'
import { HTMLAttributes } from 'react'

export default function Loader({ className }: HTMLAttributes<'div'>) {
  return (
    <div
      className={cn('flex h-svh w-full items-center justify-center', className)}
    >
      <IconLoader className='animate-spin' size={32} />
      <span className='sr-only'>loading</span>
    </div>
  )
}
